import { z } from 'zod'
import type { ItemAction } from './preparation'
import type { Slip } from './slips'

const text = z.string().nullish()
const flag = z.boolean().nullish()
const count = z.number().finite().nullish()
const person = z.object({ id: z.string(), name: text }).nullish()
const alternative = z.object({
  id: z.string(),
  prefix: text,
  name: text,
  alternativeGroupId: text,
  alternativeItemName: text,
  count,
  isChosen: flag,
  isDefault: flag,
  kitchenPresentation: text,
  productId: text,
})
const item = z.object({
  id: z.string(),
  productId: text,
  name: text,
  count,
  message: text,
  holdKitchenPrint: flag,
  needsKitchenPrint: flag,
  preparationStartedAt: text,
  preparationCompletedAt: text,
  preparationBy: person,
  alternativeItems: z.array(alternative.nullable()).nullish(),
})
export const slipSnapshotSchema = z.object({
  id: z.string(),
  humanOrderCode: text,
  createdAt: text,
  deliveryTime: text,
  estimatedDeliveryTime: text,
  riderPickupTime: text,
  orderType: text,
  backgroundColor: text,
  message: text,
  needsConfirmation: flag,
  readyForPickup: flag,
  transactionChannel: text,
  tableName: text,
  till: person,
  kitchenStationProgress: z.array(z.object({ kitchenDisplayId: z.string(), state: z.enum(['Done', 'Pending', 'NotRequired']) })).optional(),
  lineItemSections: z.array(z.object({ id: z.string(), title: text, isSecondary: flag, isCollapsed: flag, items: z.array(item.nullable()).nullish() }).nullable()).nullish(),
})
export function recallSnapshot(value: unknown): Slip | null {
  const parsed = slipSnapshotSchema.safeParse(value)
  if (!parsed.success) return null
  return {
    ...parsed.data,
    readyForPickup: false,
    needsConfirmation: false,
    kitchenStationProgress: [],
    lineItemSections: parsed.data.lineItemSections?.map(
      (section) => section && { ...section, items: section.items?.map((line) => line && { ...line, preparationStartedAt: null, preparationCompletedAt: null, preparationBy: null }) },
    ),
  }
}
/** A retained/ recalled ticket is a local task; its native order may already be closed. */
export function prepareSnapshot(slip: Slip, itemId: string, action: ItemAction, now: string): Slip {
  return {
    ...slip,
    lineItemSections: slip.lineItemSections?.map(
      (section) =>
        section && {
          ...section,
          items: section.items?.map((line) =>
            line?.id === itemId ? { ...line, preparationStartedAt: action === 'clear' ? null : (line.preparationStartedAt ?? now), preparationCompletedAt: action === 'finish' ? now : null } : line,
          ),
        },
    ),
  }
}
